export default __webpack_public_path__ + "static/media/downArrow.feac35da.svg";